let loaded = null

export default function loadVimeoAPI() {
  if (loaded !== null) return loaded

  if (window.Vimeo && window.Vimeo.loaded) {
    loaded = Promise.resolve()
    return loaded
  }

  // Otherwise, load API
  loaded = new Promise((resolve) => {
    const tag = document.createElement("script")
    tag.src = "https://player.vimeo.com/api/player.js"
    tag.onload = resolve
    document.body.appendChild(tag)
  })

  return loaded
}
